import React, { useRef, useState } from "react";
import { uploadImage, authImageUrl } from "../../lib/storage";
import { Camera, Loader2 } from "lucide-react";

export default function PhotoUpload({ value, onChange, size = 96, testId = "photo-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const choose = () => ref.current?.click();

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    setErr("");
    try {
      const res = await uploadImage(f);
      onChange?.(res.url, res);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  const src = value ? authImageUrl(value) : null;

  return (
    <div className="inline-flex flex-col items-center gap-1" data-testid={testId}>
      <button
        type="button"
        onClick={choose}
        className="relative group border border-white/15 hover:border-pitch transition-colors overflow-hidden bg-[#0A1628]"
        style={{ width: size, height: size }}
      >
        {src ? (
          <img src={src} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white/30">
            <Camera className="w-6 h-6" />
          </div>
        )}
        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          {busy ? <Loader2 className="w-5 h-5 animate-spin text-pitch" /> : <Camera className="w-5 h-5 text-pitch" />}
        </div>
      </button>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`${testId}-input`} />
      {err && <div className="text-red-400 text-[10px] font-mono">{err}</div>}
    </div>
  );
}
